import {getCookie, setCookie} from "../common/util";

const cookieDurationInDays = 30;
const cookieName = "cookie-banner-rbc";

// This banner is now integrated in EGC instead of vitrine fragment. Do not delete this code unless the banner is deleted from My Cards page

$(() => {
    init();

    $("#close-rbc-banner").on("click", function () {
        accept();
    });
});

function init() {
    if (!getCookie(cookieName)) {
        $("#rbc-banner").show();
    }
}

function accept() {
    setCookie(cookieName, cookieDurationInDays);
    $("#rbc-banner").slideUp(600);
}

